import React from 'react';
import configuration from './../../configuration/server';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getFullName } from '../../utilities/string';

class Drift extends React.Component {
    constructor(props) {
        super(props);

        this.load = this.load.bind(this);
        this.addIdentity = this.addIdentity.bind(this);
        this.insertScript = this.insertScript.bind(this);
    }

    load() {
        const { STAGE } = configuration;
        const { appId } = configuration[STAGE].drift;

        const scriptText = `!function() {
            var t = window.driftt = window.drift = window.driftt || [];
            if (!t.init) {
              if (t.invoked) return void (window.console && console.error && console.error("Drift snippet included twice."));
              t.invoked = !0, t.methods = [ "identify", "config", "track", "reset", "debug", "show", "ping", "page", "hide", "off", "on" ], 
              t.factory = function(e) {
                return function() {
                  var n = Array.prototype.slice.call(arguments);
                  return n.unshift(e), t.push(n), t;
                };
              }, t.methods.forEach(function(e) {
                t[e] = t.factory(e);
              }), t.load = function(t) {
                var e = 3e5, n = Math.ceil(new Date() / e) * e, o = document.createElement("script");
                o.type = "text/javascript", o.async = !0, o.crossorigin = "anonymous", o.src = "https://js.driftt.com/include/" + n + "/" + t + ".js";
                var i = document.getElementsByTagName("script")[0];
                i.parentNode.insertBefore(o, i);
              };
            }
          }();
          drift.SNIPPET_VERSION = '0.3.1';
          drift.load('${appId}');`;

        this.insertScript(scriptText);
    }

    addIdentity() {
        const { user } = this.props;
        if (!user) return;

        const { id, email } = user;

        if (user) {
            let scriptText = `
              var t = window.driftt = window.drift = window.driftt || [];
              drift.identify('${id}', ${JSON.stringify({ email, name: getFullName(user) })})
            `;
            this.insertScript(scriptText);
        }
    }

    insertScript(scriptText) {
        const script = document.createElement('script');
        script.innerText = scriptText;
        script.async = true;
        document.body.appendChild(script);
    }

    componentDidMount() {
        if (typeof window !== 'undefined') {
            this.load();
            this.addIdentity();
        }
    }

    render() {
        return null;
    }
}

const mapStateToProps = state => ({
    user: state.identity.profile
});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Drift);



// WEBPACK FOOTER //
// ./src/components/drift/index.jsx